import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ActiveAccount = {
  id: number;
  name: string;
  type: string;
};

export interface ActiveAccountState {
  currentAccount: ActiveAccount | null;
  isLocked: boolean;
}

const initialState: ActiveAccountState = {
  currentAccount: null,
  isLocked: false
};

const activeAccountSlice = createSlice({
  name: "activeAccount",
  initialState,
  reducers: {
    setActiveAccount: (state, action: PayloadAction<ActiveAccount | null>) => {
      state.currentAccount = action.payload;
      state.isLocked = false;
    },
    clearActiveAccount: (state) => {
      state.currentAccount = null;
      state.isLocked = true;
    }
  }
});

export const { setActiveAccount, clearActiveAccount } =
  activeAccountSlice.actions;

export default activeAccountSlice.reducer;
